import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../../../shared/services/error-handler.service';

// services
import { EventsService } from '../../../booking/services/events.service';
import { LoginService } from '../../../shared/services/login.service';

@Component({
  selector: 'app-set-password-section',
  templateUrl: './set-password-section.component.html',
  styleUrls: ['./set-password-section.component.scss'],
  providers: [EventsService, LoginService, ErrorHandler]
})
export class SetPasswordSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
